var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoginPopupWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 16,
    fill: "#EF4444"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5403 11.2423C18.5538 9.21545 21.4463 9.21545 22.4597 11.2423L30.2236 26.7702C31.1379 28.5987 29.8083 30.75 27.764 30.75H12.2361C10.1918 30.75 8.86218 28.5987 9.77642 26.7702L17.5403 11.2423ZM20.5584 23.0034L21.3247 16.4897C21.418 15.6967 20.7984 15 19.9999 15C19.2015 15 18.5819 15.6967 18.6752 16.4897L19.4415 23.0034C19.4748 23.2866 19.7148 23.5 19.9999 23.5C20.2851 23.5 20.5251 23.2866 20.5584 23.0034ZM20.9999 26C20.9999 26.5523 20.5522 27 19.9999 27C19.4477 27 18.9999 26.5523 18.9999 26C18.9999 25.4477 19.4477 25 19.9999 25C20.5522 25 20.9999 25.4477 20.9999 26Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginPopupWarning);
export default __webpack_public_path__ + "static/media/login-popup-warning.8bafae3972af4a88110405236e696716.svg";
export { ForwardRef as ReactComponent };